export default __webpack_public_path__ + "static/media/12.150fa623.png";